import axios from "axios";

export const GET_ALUMNO_LIST                = "GET_ALUMNO_LIST";
export const GET_ALUMNO_DETAIL              = "GET_ALUMNO_DETAIL";
export const PUT_ALUMNO_EDIT                = "PUT_ALUMNO_EDIT";
export const POST_ALUMNO_CREATE             = "POST_ALUMNO_CREATE";
export const DELETE_ALUMNO                  = "DELETE_ALUMNO";
export const PUT_ALUMNO_COBRO               = "PUT_ALUMNO_COBRO";
export const PUT_ALUMNO_COBRO_H             = "PUT_ALUMNO_COBRO_H";
export const PUT_ALUMNO_COBRO_SERVICIO      = "PUT_ALUMNO_COBRO_SERVICIO";

export const PUT_ALUMNO_COBRO_EN_PAGOS = "PUT_ALUMNO_COBRO_EN_PAGOS";


export const PUT_CERRAR_CORTE_CAJA = "PUT_CERRAR_CORTE_CAJA";


export const GET_CORTE_CAJA = "GET_CORTE_CAJA";

export const GET_CORTE_CAJA_PagoPorConceptoCobro    = "GET_CORTE_CAJA_PagoPorConceptoCobro";

export const GET_CORTE_CAJA_PagoPoUsuarioAlta       = "GET_CORTE_CAJA_PagoPoUsuarioAlta";

export const GET_CORTE_CAJA_PagoPorTipoPago         = "GET_CORTE_CAJA_PagoPorTipoPago";

export const GET_CORTE_CAJA_CobroPorUsuario         = "GET_CORTE_CAJA_CobroPorUsuario";


export const GET_CORTE_CAJA_PagoPorConceptoCobroPorUsuario  = "GET_CORTE_CAJA_PagoPorConceptoCobroPorUsuario";
export const GET_CORTE_CAJA_PagoPoUsuarioAltaPorUsuario     = "GET_CORTE_CAJA_PagoPoUsuarioAltaPorUsuario";
export const GET_CORTE_CAJA_PagoPorTipoPagoPorUsuario       = "GET_CORTE_CAJA_PagoPorTipoPagoPorUsuario";

export const GET_CORTE_CAJA_ComisionUsuario                 = "GET_CORTE_CAJA_ComisionUsuario";

export const GET_CORTE_CAJA_ConsolidadoUsuario              = "GET_CORTE_CAJA_ConsolidadoUsuario";


export const getPagoPorConceptoCobro = (feci, fecf) => {

    return (dispatch) => {
        //console.log("Javier -------> Se carga ACTION | getUsersList");
        axios
            .get("/api/Alumno/ObtienePagoPorConceptoCobro?feci=" + feci + "&fecf=" + fecf)
            .then(function (response) {
                //console.log(response.data);
                dispatch({
                    type: GET_CORTE_CAJA_PagoPorConceptoCobro,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });

            })
            .catch(function (error) {
                dispatch({
                    type: GET_CORTE_CAJA_PagoPorConceptoCobro,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });
    };
};

export const getPagoPorUsuarioAlta = (feci, fecf) => {

    return (dispatch) => {
        //console.log("Javier -------> Se carga ACTION | getUsersList");
        axios
            .get("/api/Alumno/ObtienePagoPorUsuarioAlta?feci=" + feci + "&fecf=" + fecf)
            .then(function (response) {
                //console.log(response.data);
                dispatch({
                    type: GET_CORTE_CAJA_PagoPoUsuarioAlta,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });

            })
            .catch(function (error) {
                dispatch({
                    type: GET_CORTE_CAJA_PagoPoUsuarioAlta,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });
    };
};

export const getPagoPorTipoPago = (feci, fecf) => {

    return (dispatch) => {
        //console.log("Javier -------> Se carga ACTION | getUsersList");
        axios
            .get("/api/Alumno/ObtienePagoPorTipoPago?feci=" + feci + "&fecf=" + fecf)
            .then(function (response) {
                //console.log(response.data);
                dispatch({
                    type: GET_CORTE_CAJA_PagoPorTipoPago,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });

            })
            .catch(function (error) {
                dispatch({
                    type: GET_CORTE_CAJA_PagoPorTipoPago,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });
    };
};


//------------------------------------------------------------------
export const getPagoPorConceptoCobroPorUsuario = (id) => {

    return (dispatch) => {
        //console.log("Javier -------> Se carga ACTION | getUsersList");
        axios
            .get("/api/Alumno/ObtienePagoPorConceptoCobroPorUsuario?id="+id)
            .then(function (response) {
                //console.log(response.data);
                dispatch({
                    type: GET_CORTE_CAJA_PagoPorConceptoCobroPorUsuario,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });

            })
            .catch(function (error) {
                dispatch({
                    type: GET_CORTE_CAJA_PagoPorConceptoCobroPorUsuario,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });
    };
};

export const getPagoPorUsuarioAltaPorUsuario = (id) => {

    return (dispatch) => {
        //console.log("Javier -------> Se carga ACTION | getUsersList");
        axios
            .get("/api/Alumno/ObtienePagoPorUsuarioAltaPorUsuario?id="+id)
            .then(function (response) {
                //console.log(response.data);
                dispatch({
                    type: GET_CORTE_CAJA_PagoPoUsuarioAltaPorUsuario,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });

            })
            .catch(function (error) {
                dispatch({
                    type: GET_CORTE_CAJA_PagoPoUsuarioAltaPorUsuario,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });
    };
};

export const getPagoPorTipoPagoPorUsuario = (id) => {

    return (dispatch) => {
        //console.log("Javier -------> Se carga ACTION | getUsersList");
        axios
            .get("/api/Alumno/ObtienePagoPorTipoPagoPorUsuario?id="+id)
            .then(function (response) {
                //console.log(response.data);
                dispatch({
                    type: GET_CORTE_CAJA_PagoPorTipoPagoPorUsuario,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });

            })
            .catch(function (error) {
                dispatch({
                    type: GET_CORTE_CAJA_PagoPorTipoPagoPorUsuario,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });
    };
};

export const getCobroPorUsuario = (id) => {

    return (dispatch) => {
        //console.log("Javier -------> Se carga ACTION | getUsersList");
        axios
            .get("/api/Costo/ObtieneCostoPorId?id=" + id)
            .then(function (response) {
                //console.log(response.data);
                dispatch({
                    type: GET_CORTE_CAJA_CobroPorUsuario,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });

            })
            .catch(function (error) {
                dispatch({
                    type: GET_CORTE_CAJA_CobroPorUsuario,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });
    };
};

export const getComisionesPorUsuario = (id) => {

    return (dispatch) => {
        //console.log("Javier -------> Se carga ACTION | getUsersList");
        axios
            .get("/api/Alumno/ObtieneComisionesPorUsuario?id=" + id)
            .then(function (response) {
                //console.log(response.data);
                dispatch({
                    type: GET_CORTE_CAJA_ComisionUsuario,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });

            })
            .catch(function (error) {
                dispatch({
                    type: GET_CORTE_CAJA_ComisionUsuario,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });
    };
};

export const getConsolidadoPorUsuario = (id) => {

    return (dispatch) => {
        //console.log("Javier -------> Se carga ACTION | getUsersList");
        axios
            .get("/api/Alumno/ObtieneConsolidadoPorUsuario?id=" + id)
            .then(function (response) {
                //console.log(response.data);
                dispatch({
                    type: GET_CORTE_CAJA_ConsolidadoUsuario,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });

            })
            .catch(function (error) {
                dispatch({
                    type: GET_CORTE_CAJA_ConsolidadoUsuario,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });
    };
};
//------------------------------------------------------------------




export const getCorteCaja = (idusuario) => {

    return (dispatch) => {
        //console.log("Javier -------> Se carga ACTION | getUsersList");

        axios
            .get("/api/Alumno/CorteCajaPorUsuario?idusuario=" + idusuario)
            .then(function (response) {
                //console.log(response.data);
                dispatch({
                    type: GET_CORTE_CAJA,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });

            })
            .catch(function (error) {
                dispatch({
                    type: GET_CORTE_CAJA,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });
    };
};


export const getAlumnoList = () => {

    return (dispatch) => {
        //console.log("Javier -------> Se carga ACTION | getUsersList");
        axios
            .get("/api/Alumno/ObtieneTodosLosAlumnos")
            .then(function (response) {
                //console.log(response.data);
                dispatch({
                    type: GET_ALUMNO_LIST,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });

            })
            .catch(function (error) {
                dispatch({
                    type: GET_ALUMNO_LIST,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });
    };
};

export const getAlumnoDetail = (id) => {

    //console.log("----->ingresa getAlumnoDetail");

    return (dispatch) => {
        axios
            .get(
                "/api/Alumno/ObtieneAlumnoPorId?id=" +id
            )
            .then(function (response) {
                //console.log(response.data);

                dispatch({
                    type: GET_ALUMNO_DETAIL,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });
            })
            .catch(function (error) {
                dispatch({
                    type: GET_ALUMNO_DETAIL,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });

    }; //END DISPATCH
}; //END DETAIL

export const putAlumnoUpdate = (data, id) => {

    return (dispatch) => {
        axios
            .put(
                "/api/Alumno/" + id,data
                )
            .then(function (response) {
                //console.log(response);

                dispatch({
                    type: PUT_ALUMNO_EDIT,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });
            })
            .catch(function (error) {
                dispatch({
                    type: PUT_ALUMNO_EDIT,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });

    }; //END DISPATCH

}; //END UPDATE

export const putAlumnoCobro = (data, id) => {

    return (dispatch) => {

        //console.log("---->id alumno: "+id);

        sessionStorage.setItem('idalumno', id);

        axios
            .put(
                "/api/Alumno/CobroAlumno/" + id, data
            )
            .then(function (response) {
                dispatch({
                    type: PUT_ALUMNO_COBRO,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });
            })
            .catch(function (error) {
                dispatch({
                    type: PUT_ALUMNO_COBRO,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });

    }; //END DISPATCH

}; //END UPDATE

export const putCerrarCorteCaja = (data,id) => {

    return (dispatch) => {

        //console.log("---------> INGRESA A PUT CORTE CAJA");

        //console.log("---------> ID ENVIADO --->"+id);

        //console.log("---------> " + JSON.stringify(data));

        //console.log("--------->ID USUARIO---> " + sessionStorage.getItem('idusuario'));

        
        axios
            .put(
                "/api/Alumno/CerrarCorteCajaActual/" + id, data
            )
            .then(function (response) {
                dispatch({
                    type: PUT_CERRAR_CORTE_CAJA,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });
            })
            .catch(function (error) {
                dispatch({
                    type: PUT_CERRAR_CORTE_CAJA,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });

        

    }; //END DISPATCH

}; //END UPDATE



export const putAlumnoCobroH = (data, id) => {

    return (dispatch) => {
        axios
            .put(
                "/api/AlumnoHistoria/CobroAlumno/" + id, data
            )
            .then(function (response) {
                //console.log(response);

                dispatch({
                    type: PUT_ALUMNO_COBRO_H,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });
            })
            .catch(function (error) {
                dispatch({
                    type: PUT_ALUMNO_COBRO_H,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });

    }; //END DISPATCH

}; //END UPDATE


export const putAlumnoCobroServicio = (data, id) => {

    return (dispatch) => {
        axios
            .put(
                "/api/AlumnoServicio/CobroServicioAlumno/" + id, data
            )
            .then(function (response) {
                //console.log(response);

                dispatch({
                    type: PUT_ALUMNO_COBRO_SERVICIO,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });
            })
            .catch(function (error) {
                dispatch({
                    type: PUT_ALUMNO_COBRO_SERVICIO,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });

    }; //END DISPATCH

}; //END UPDATE

export const postAlumnoCreate = (data) => {

    //console.log(data);
   // debugger
    

    return (dispatch) => {
        axios
        .post(
            "/api/Alumno",data
        )
        .then(function (response) {
            //console.log(response);
        
            dispatch({
                type: POST_ALUMNO_CREATE,
                payload: {
                    data: response.data,
                    errorMessage: false,
                },
            });
        })
        .catch(function (error) {
           // debugger

            dispatch({
                type: POST_ALUMNO_CREATE,
                payload: {
                    data: false,
                    errorMessage: error.message,
                },
            });
        });
    };
  
};

export const deleteAlumno = (data, id) => {

    return (dispatch) => {

        //console.log("ACTION deleteAlumno");

        axios
            .put(
                "/api/Alumno/BorrarAlumno/" + id, data
            )
            .then(function (response) {
                //console.log(response);

                dispatch({
                    type: DELETE_ALUMNO,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });
            })
            .catch(function (error) {
                dispatch({
                    type: DELETE_ALUMNO,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });

    }; //END DISPATCH
    
};

export const putAlumnoCobroEnPagos = (data, id) => {

    return (dispatch) => {

        //console.log("---->id alumno: " + id);

        sessionStorage.setItem('idalumno', id);

        axios
            .put(
                "/api/Alumno/CobroParcialAlumno/" + id, data
            )
            .then(function (response) {
                dispatch({
                    type: PUT_ALUMNO_COBRO_EN_PAGOS,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });
            })
            .catch(function (error) {
                dispatch({
                    type: PUT_ALUMNO_COBRO_EN_PAGOS,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });

    }; //END DISPATCH

}; //END UPDATE
